module.exports = __webpack_public_path__ + "static/img/gold_banner.06ed863.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img2/gold_banner.png
// module id = w1vi
// module chunks = 1